/**
 * Created by hernanherreros on 2019-05-27
 */

import React, { useState } from 'react'
import styled from 'styled-components'
import LottieAnimation from '../../components/Utils/LottieAnimation'
import animation from '../../static/animations/not-found.json'
import { Trans } from '@lingui/macro'
import withLocale, { ComponentProps } from '../Locale/withLocale'
import { Button } from 'antd'
import { Document, Page } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';

interface Props extends ComponentProps {
  congress: any;
  message: any;
  url: any;
}

function DisabledMessage ({locale, congress, message, url }: Props) {
    let logoUrl, slogan

  if (!locale) {
    logoUrl = congress.LogoURL
    slogan = congress.Slogan
  } else {
    switch (locale.currentLanguage) {
      case 'es':
        logoUrl = congress.LogoURL
        slogan = congress.Slogan
        break
      case 'en':
        logoUrl = congress.LogoURL
        slogan = congress.Slogan
        break
    }
  }
  console.log('congress', congress)
  const logo = logoUrl ? (
    <Logo src={logoUrl} alt={congress.Name}/>
  ) : (
    <Name>{congress.Name}</Name>
  )

  console.log('message', message)

    return(
      <Container>
        <Wrapper>
          {logo}
          {message === '' ? <Text>Inscripciones Finalizadas</Text> : <Text>{message}</Text>}
          {message === '' && <SubText><Trans>¡Gracias por participar!</Trans></SubText>}
          {url !== '' && <a target="_blank" href={url}>
              <Button type="primary" size="large" >Ver Comunicado</Button>
            </a>  
          } 
        </Wrapper>
      </Container>
    )
  
}

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
`

const Logo = styled.img<any>`
  max-width: 300px;
  width: 100%;
  object-fit: contain;
  margin: 16px auto;
  display: block
`

const Name = styled.h1`
  margin: 0;
  font-weight: 400;
`

const Wrapper = styled.div`
  max-width: 400px;
  width: 100%;
  text-align: center;  
`
const Text = styled.h1`
  font-weight: 300;
  color: #666;
  text-align: center;  
  margin: 0;
  margin-top: 50px;
  margin-bottom: 30px;
  
  @media screen and (max-width: 400px) {
    font-size: 20px;
  }
 `

const SubText = styled.h1`
  font-weight: 300;
  color: #666;
  text-align: center;
  
  @media screen and (max-width: 400px) {
    font-size: 20px;
  }
 `

export default withLocale(DisabledMessage)